import React, { useState, useEffect, ReactNode } from "react";
import { Table } from "react-bootstrap";
import axios from "axios";
import { Elements, useStripe } from "@stripe/react-stripe-js";
import CardInfo from "./../card/CardInfo";
import styles from "./Bank.module.scss";

interface BankInterface {
  financial: string;
  branch: string;
  deposit_type: string;
  account_number: string;
  account_name: string;
}

interface IProps {
  topChildren: ReactNode;
  bottomChildren: ReactNode;
  onSubmit: () => Promise<void>;
  card: any;
  stripePromise: any;
  isValid: boolean;
}

const RegisteredCardForm = (props: Omit<IProps, "stripePromise">) => {
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const stripe = useStripe();

  const handleOnSubmit = async (e: React.FormEvent) => {
    try {
      e.preventDefault();
      if (isProcessing || !stripe) return;
      setIsProcessing(true);
      await props.onSubmit();
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <form onSubmit={handleOnSubmit} className={styles.form}>
      {props.topChildren}

      <CardInfo card={props.card} />

      {props.bottomChildren}
      <button
        type="submit"
        className={styles.submitButton}
        disabled={isProcessing || !stripe || !props.isValid}
      >
        {isProcessing ? "Processing..." : "購入"}
      </button>
    </form>
  );
};

const RegisteredCard = (props: IProps) => (
  <Elements stripe={props.stripePromise}>
    <RegisteredCardForm {...props} />
  </Elements>
);

export default RegisteredCard;
